import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-input-tag',
  templateUrl: './input-tag.component.html',
  styleUrls: ['./input-tag.component.scss']
})
export class InputTagComponent {


  /**
   * 
   * @param - The width is applied to the component.
   * 
   *   <app-input-tag class="exemplo-width"
   *     [TG_icon]="'icon_user'"
   *     [TG_label]="'Convidar participantes'"
   *     [TG_Regex]="regex"
   *     (sendTags)="sendTags($event)">
   *   </app-input-tag>
   * 
   * exemplo-width {
   * width: 300px | 30vw | 30% ...
   * }
   *
   */

  public innerValue = '';

  @Input() public TG_list: string [] = [];

  /**
   * @param /receives a regex for validation
   */
  @Input() public TG_Regex = '';

  @Input() public TG_icon = '';
  @Input() public TG_label = '';

  @Output() public sendTags =  new EventEmitter<any>();


  public TG_Pattern = false;
  public shake = false;

  public tgEnter(event: Event | any): void {
    this.TG_Pattern = false;
    this.shake = false;
    this.tgValidator(this.innerValue);
    this.tgClearAdding(event.keyCode);
    this.shakeAction(event.keyCode);
  }

  private shakeAction(keyCode: number): void {
    if (keyCode === 13 || keyCode === 9) {
      setTimeout(() => {
        if (!this.TG_Pattern) {
          this.shake = true;
        }
      }, 120);
    }
  }

  public tgClearAdding(keyCode: number) {
    if (this.innerValue === '' && keyCode === 8) {
      this.TG_list.pop();
      this.sendTags.emit(this.TG_list);
    }
    if (this.TG_Pattern && (keyCode === 13 || keyCode === 9)) {
      this.TG_list.push(this.innerValue);
      this.innerValue = '';
      this.sendTags.emit(this.TG_list);
    }
  }

  public tgSet(): void {
    if (this.innerValue && this.innerValue !== null && this.TG_Pattern) {
      this.TG_list.push(this.innerValue);
      this.innerValue = '';
      this.sendTags.emit(this.TG_list);
    }
    if (this.TG_list.length && !this.TG_Pattern) {
      this.shake = true;
    }
  }

  public tgValidator(data: string): boolean {
    if (data && data !== '') {
      const validator = RegExp(this.TG_Regex);
      this.TG_Pattern = validator.test(data);
      if (this.tgDuplicate()) {
        this.TG_Pattern = false;
      }
      return this.TG_Pattern;
    }
  }

  public tgDuplicate(): boolean {
    let flag = false;
    this.TG_list.forEach(x => {
      if (x.toLocaleLowerCase() === this.innerValue.toLocaleLowerCase()) {
        flag = true;
      }
    });
    return flag;
  }

  public tgRemove(index: number) {
    if (this.innerValue.trim().length > 0) {
      return;
    } else {
      this.TG_list.splice(index, 1);
      this.innerValue = '';
      this.sendTags.emit(this.TG_list);
    }
  }


}